import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthService } from '../services/auth'

/**
 * ログアウト時のみ表示する公開ページ用。すでにサインイン済みならアプリ内へ送る。
 * returnUrl があればそこへ、なければ先生・管理者は先生ページ、生徒は動画一覧へ。
 */
export const useRedirectIfSignedIn = (returnUrl: string | null) => {
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        const user = await AuthService.getCurrentUser()
        if (user) {
          let defaultDestination = '/videos'
          if (['teacher', 'admin', 'super_admin'].includes(user.role)) {
            defaultDestination = '/teacher'
          }
          const destination = returnUrl ? decodeURIComponent(returnUrl) : defaultDestination
          navigate(destination)
        }
      } catch {
        // User is not authenticated, stay on the public page
        console.log('User not authenticated, staying on landing page')
      }
    }

    checkAuthAndRedirect()
  }, [navigate, returnUrl])
}
